<template>
  <button
    id="bubbleButton"
    type="button"
    class="bubble"
    :aria-label="buttonLabel"
    @click="handleBubbleClicked"
  >
    <transition name="toggling-bubble">
      <div v-if="!isOpen">
        <img
          v-if="chosenAvatarImage"
          :src="chosenAvatarImage"
          :alt="headerTitle"
          aria-labelledby="bubbleButton"
          class="avatar-in-bubble"
        >
      </div>
      <div v-else>
        <svg
          v-if="!isOpen"
          key="open"
          viewBox="0 0 30 30"
          width="32"
          class="chat-icon-trigger svg-block"
          aria-labelledby="bubbleButton"
        >
          <use
            xlink:href="#icon-chat"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          />
        </svg>
      </div>
    </transition>
    <transition name="toggling-bubble">
      <svg
        v-if="isOpen"
        key="close"
        viewBox="0 0 30 30"
        width="24"
        class="chat-icon-trigger svg-block"
        fill="white"
      >
        <use
          xlink:href="#icon-close"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        />
      </svg>
    </transition>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  mixins: [],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['animatedAvatarImage', 'avatarImage', 'headerTitle', 'isShowingWelcomeMessage']),
    chosenAvatarImage (): string {
      if (this.isShowingWelcomeMessage) {
        return this.animatedAvatarImage
      } else {
        return this.avatarImage
      }
    },
    buttonLabel () {
      if (this.isOpen) return this.$t('chatbot.close')

      return this.$t('chatbot.supportChat')
    }
  },
  methods: {
    handleBubbleClicked () {
      this.$emit('click')
    }
  }
}
</script>

<style src="./chat-bubble.scss"></style>
